import { Pipe, PipeTransform } from '@angular/core';
import { Booth, Hall } from '@planone/shared/util-interfaces';

@Pipe({ name: 'LocationName' })
export class LocationNamePipe implements PipeTransform {
  transform(data: { hall: Hall; booth: Booth }) {
    return `${data.hall.name}.${data.booth.name}`;
  }
}
